<template>
  <div class="aside">
    <ul>
        <li v-for="(item,index) in activeMenu" :key='index'>
          <h1 :class="{active:(isActive===index?true:false)}">
            <i class="iconfont icon-02"></i>
            {{item.rescmc}}
            <i class="iconfont icon-jiantou_down" v-if='item.children.length'></i>
          </h1>
          <ul v-if='item.children.length'>
            <router-link v-on:click.native="change(index)" class="menuItem" tag="li" v-for="s in item.children" :to="{path:s.realresc}" :key='s.realresc'>
              <i class="iconfont icon-iconquanzi"></i>
              {{s.rescmc}}
            </router-link>
          </ul>
        </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Aside",
  data() {
    return {
        activeMenu:[
          {rescmc:'系统管理',children:[
            {rescmc:'资源管理',realresc:'zygl'},
            {rescmc:'权限管理',realresc:'qxgl'},
            {rescmc:'角色管理',realresc:'jsgl'},
            {rescmc:'登录管理',realresc:'dlgl'},
            {rescmc:'归属机构',realresc:'gsjggl'},
            ]
          },
          {rescmc:'配置管理',children:[{rescmc:'流程配置',realresc:'lcpz'},{rescmc:'流程管理',realresc:'lcgl'},{rescmc:'码表管理',realresc:'mbgl'}]},
          {rescmc:'开标设置',children:[{rescmc:'开标设置',realresc:'kbsz'}]}
        ],
        isActive:0
    };
  },
  mounted() {
  },
 
  methods: {
    change(i) {
      this.isActive=i
    }
  },
};
</script>
<style lang="less" scoped>
.aside {
  width: 235px;
  background: #eff2f6;
  border-right: 1px solid #ddd;
  padding-top: 10px;
  height: calc(~"100% - 80px");
  position: absolute;
  top: 80px;
  left: 0;
}
.menuItem {
  color: #333;
  height: 50px;
  line-height: 50px;
  padding-left: 55px;
  cursor: pointer;
}
.menuItem.router-link-active {
  color: #d70a30;
}
h1 {
  font-size: 16px;
  color: #fff;
  padding: 0 20px 0 38px;
  height: 50px;
  line-height: 50px;
  background: #9c9c9c;
  font-weight: 400;
  position: relative;
  margin-right: -1px;
}
h1.active {
  background: #d70a30;
}
.icon-02 {
  margin-right: 10px;
}
.icon-iconquanzi {
  margin-right: 5px;
  position: relative;
  top: 2px;
}
.icon-jiantou_down {
  position: absolute;
  right: 20px;
  top: 0px;
}
.icon-tuichudenglu {
  margin-right: 3px;
}
</style>

